/**
 * UI v2 design tokens (light), from design-reference/enterprise-shell.
 *
 * Only v2 code imports this. Legacy pages keep styles/tokens/colors.js and
 * assets/theme/base/colors.js untouched.
 *
 * Contrast rules (CLAUDE.md): white text on any dark fill; on a tint, accent
 * text uses the darker `ink` colour. Every pair below passes WCAG AA.
 */

// Body and interface text use Red Hat Text, the family's cut drawn for 12-16px:
// more open letterforms and spacing, so it stays crisp at table and form
// sizes. Red Hat Display is kept for headings, page titles and large numbers.
export const V2_FONT_FAMILY =
  '"Red Hat Text", "Red Hat Display", ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif';

export const V2_DISPLAY_FONT_FAMILY =
  '"Red Hat Display", "Red Hat Text", ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif';

export const V2_HEADER_GRADIENT =
  "linear-gradient(90deg, #0A1B3D 0%, #0F2E66 50%, #1565C8 100%)";

export const v2 = {
  bg: "#F4F6FA",
  surface: "#FFFFFF",
  surface2: "#F8FAFC",
  hover: "#EEF2F7",
  panel: "#F7F9FC",
  border: "#E2E7EF",
  border2: "#CED6E2",
  text: "#0E2348",
  text2: "#44546F",
  text3: "#5D6D86",
  textDisabled: "#8A97AB",
  link: "#1565C8",
  primary: "#1565C8",
  primaryDark: "#0F4FA0",
  primaryLight: "#4B8BDB",
  onPrimary: "#FFFFFF",
  header: "#0E2348",
  headerMuted: "#B9C6DB",
  headerField: "#1A3260",
  headerFieldBorder: "#2D4777",
  gold: "#FFB400",
  onGold: "#0E2348",
  overlay: "rgba(14, 35, 72, 0.36)",
  shadow: "0 1px 2px rgba(14, 35, 72, 0.06)",
  shadowMenu: "0 8px 24px rgba(14, 35, 72, 0.12)",
  shadowPop: "0 18px 48px rgba(14, 35, 72, 0.22)",
};

/** [background, foreground] pairs for chips, badges and banners. */
export const v2Tones = {
  success: { bg: "#E5F4EB", fg: "#166534" },
  warning: { bg: "#FDF0DC", fg: "#8A4B08" },
  danger: { bg: "#FDEBEA", fg: "#B42318" },
  info: { bg: "#E6EFFB", fg: "#1453A0" },
  neutral: { bg: "#EDF0F5", fg: "#44546F" },
  purple: { bg: "#EFEAFC", fg: "#5B34B8" },
};

/** Edition identity colours. Primary actions stay brand blue in every edition. */
export const v2EditionAccents = {
  sales: { accent: "#1565C8", ink: "#0F4FA0" },
  service: { accent: "#7A4DD8", ink: "#5B34B8" },
  travel: { accent: "#0B7A75", ink: "#08625E" },
  realestate: { accent: "#B45309", ink: "#92400E" },
  highered: { accent: "#4F46E5", ink: "#4338CA" },
  healthcare: { accent: "#15803D", ink: "#166534" },
};

/** Density targets for v2 (CLAUDE.md): 14px base, 36px controls, 48px rows. */
export const v2Density = {
  baseFontPx: 14,
  controlHeightPx: 36,
  controlHeightSmallPx: 30,
  tableRowHeightPx: 48,
  tableHeadHeightPx: 36,
  radiusPx: 8,
  cardRadiusPx: 10,
};

export default v2;
